import React, {useState} from "react";
import Switch from "react-bootstrap-switch";
import {CardBody, Col, Form, FormGroup, Label, Row} from "reactstrap";
import {connect, useSelector} from "react-redux";
import {useForm} from "react-hook-form";


// components
import {ButtonClean, ButtonSearch} from "../../../components/buttons/buttonsActions";

// labels
import {LB_NAME,} from "../../../components/i18n/i18n";

// actions
import {setFilter} from "../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../redux/selectors";
import SelectGeneric from "../../../components/select/selectGeneric";
import {mainProvider} from "../../../providers/mainProvider";



const ClassConfigurationFilters = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { filter, app } = componentState?.data || {};
    const {fbDataBase} = app


    const [className, setClassName] = useState(filter?.className || null);
    const [realTime, setRealTime] = useState(filter?.realTime || null);
    const [firestore, setFirestore] = useState(filter?.firestore || null);



    const {handleSubmit, reset} = useForm({
        defaultValues: {}
    });

    const onSubmit = (data, _) => {
        const dataFilter = {
            fbDataBase,
            item : {  ...data, }
        };

        if(className !== undefined && className !== null)
            dataFilter.item.className = className;

        if(realTime !== undefined && realTime !== null)
            dataFilter.item.realTime = realTime;

        if(firestore !== undefined && firestore !== null)
            dataFilter.item.firestore = firestore;

        props.setFilter(path, dataFilter);
    };

    const cleanFields = () => {
        setClassName(null)
        setRealTime(null)
        setFirestore(null)
        reset();
    }

    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <CardBody>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>{LB_NAME}</Label>
                        <SelectGeneric
                            initialValue={ className }
                            setExternalValue={ setClassName }
                            provider={ mainProvider }
                        />
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup>
                        <Label>{'Realtime'}</Label>
                        <br/>
                        <Switch
                            animate={true}
                            offText={"No"}
                            onText={"Si"}
                            value={realTime}
                            onChange={ () => setRealTime(!realTime) }
                        />
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup>
                        <Label>{'Firestore'}</Label>
                        <br/>
                        <Switch
                            animate={true}
                            offText={"No"}
                            onText={"Si"}
                            value={firestore}
                            onChange={ () => setFirestore(!firestore) }
                        />
                    </FormGroup>
                </Col>
                <Col sm={12} className={'d-flex justify-content-center'}>
                    <div className="float-right ">
                        <ButtonSearch/>
                        <ButtonClean onClick={() => cleanFields()}/>
                    </div>
                </Col>
            </Row>
        </CardBody>
    </Form>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({setFilter})

export default connect(mapStateToProps, mapActionsToProps)(ClassConfigurationFilters)